import React from "react";

function Terms() {
  return (
    <div style={{maxWidth:"900px", margin:"auto", padding:"40px", fontFamily:"Arial"}}>

      <h1>Civilink Terms of Service</h1>
      <p><strong>Last Updated:</strong> March 2026</p>

      <p>
        These Terms of Service govern your use of Civilink, a platform operated
        by Civilink Private Limited, registered under the Ministry of Corporate
        Affairs, India.
      </p>

      <h2>1. Platform Nature</h2>
      <p>
        Civilink is a technology platform connecting engineers, architects,
        workers, vendors, and property buyers/sellers.
      </p>

      <p>
        Civilink acts as a technology intermediary and does not act as a
        contractor, real estate broker, or payment bank.
      </p>

      <h2>2. User Accounts</h2>
      <p>
        Users must provide accurate information during registration and are
        responsible for protecting their account credentials.
      </p>

      <h2>3. Marketplace & Listings</h2>
      <p>
        Users may post construction services, property listings, and vendor
        products. Civilink does not verify property ownership or guarantee
        service quality.
      </p>

      <h2>4. User Responsibility</h2>
      <p>
        Transactions between users are conducted at their own risk. Civilink is
        not responsible for disputes arising between users.
      </p>

      <h2>5. Platform Misuse</h2>
      <p>
        Fraud, impersonation, illegal listings, and abusive behavior are strictly
        prohibited and may result in account suspension.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        Civilink provides services on an "as-is" basis and shall not be liable
        for indirect damages arising from platform usage.
      </p>

      <h2>7. Jurisdiction</h2>
      <p>
        These terms are governed by the laws of India and subject to jurisdiction
        of courts in Tamil Nadu.
      </p>

      <h2>8. Contact</h2>
      <p>
        Civilink Private Limited<br/>
        Tamil Nadu, India<br/>
        Email: civilink.official@gmail.com
      </p>

    </div>
  );
}

export default Terms;